// extracted by mini-css-extract-plugin
export default {"deeper":"Deeper_deeper__fj+0o","deeper1":"Deeper_deeper1__VE0Fp","deeper2":"Deeper_deeper2__dU2iy","deeper3":"Deeper_deeper3__uSVkS","deeper4":"Deeper_deeper4__lntsP"};